export default __webpack_public_path__ + "static/media/win-parameter.59e75d91.svg";